import cloneDeep from 'lodash/cloneDeep';
import {
  DatatypeRange,
  OperatorType,
  QueryBuilder,
  XSD_DATATYPE_IRIS,
} from 'vet-bones/utils/queryBuilder';

import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

const updateQueryBuilderAttributeRange =
  (attribute: ModelConceptAttribute) => (rule: QueryBuilder) => {
    rule.data.query.expressions.forEach((subExpression) =>
      subExpression.expressions.forEach((expression) =>
        expression.filters.forEach((filter) => {
          const { operator } = filter;
          if (
            operator &&
            operator.operatorType === OperatorType.DATATYPE &&
            operator.iri === attribute.value
          ) {
            operator.range =
              Object.keys(attribute.ranges).find(
                (rangeIri): rangeIri is NonNullable<DatatypeRange> =>
                  XSD_DATATYPE_IRIS.includes(rangeIri as any)
              ) || null;
          }
        })
      )
    );
  };

export const updateRuleAttributeRange =
  (attribute: ModelConceptAttribute) => (model: Model) => {
    // check if attribute is in any sensitive property groups
    const rulesById = cloneDeep(model.modelData.rulesById);
    const updateQueryBuilder = updateQueryBuilderAttributeRange(attribute);
    Object.values(rulesById).forEach((rule) => {
      if (rule.ifClause) {
        updateQueryBuilder(rule.ifClause);
      }
      if (rule.thenClause) {
        updateQueryBuilder(rule.thenClause);
      }
    });
    setDataProperty<ModelData>(model)(model.modelData, 'rulesById', rulesById);
  };
